import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const CareInstructions: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product?.careInstructions) return null;
  const headingColor = context.product.headingColor || "#000000";
  const textColor = context.product.textColor || "#000000";

  return (
    <div className="w-full max-w-2xl mx-auto px-4 pb-5 font-mulish text-left">
      <h2 style={{ letterSpacing: "0.01em", color: headingColor }} className="text-base font-bold text-gray-900 leading-tight pb-2">
        Care Instructions
      </h2>
      <p style={{color: textColor}}  className="text-sm mt-1 leading-snug">
        {context.product.careInstructions}
      </p>
    </div>
  );
};

export default CareInstructions;
